<template>
  <myDialog :isDialog="isDialog" :isHeader="true" @handleClose="$emit('handleClose')">
      <template slot="content">
        <div class="zzjgt">
          <img class="close" @click="$emit('handleClose')" src="@/assets/images/newHome/close.png" alt="">
          <img class="jgt" src="@/assets/images/newHome/zzjgt.png" alt="">
        </div>
      </template>
  </myDialog>
</template>

<script>
export default {
props:{
  isDialog:{
    type:Boolean,
    default:false,
  }
},
data() {
  return {}
},
mounted() {
  
},
methods: {},
}
</script>
<style lang="scss" scoped>
  /deep/.el-dialog{
    background: #041E37;
    border-radius: 20px !important;
  }
  /deep/.el-dialog__body{
    overflow: hidden!important;
    padding: 0!important;
  }
.zzjgt{
  position: relative;
  padding-top: 50px;
  background-image: url('../../../assets/images/newHome/zzjgt-bj.png');
  background-repeat: no-repeat;
  background-position: top;
  background-size: 100% 100%;
  overflow: hidden;
  
  .close{
    position: absolute;
    top: 9px;
    right: 20px;
    width: 24px;
    height: 24px;
  }
  .jgt{
    width: 100%;
    height: 100%;
  }
}
</style>
